import { useState, useEffect } from "react";
import { ShoppingBag, Menu, X, Youtube } from "lucide-react";
import { useCart } from "../context/CartContext";

const links = [
  { label: "Episodes", href: "#episodes" },
  { label: "About", href: "#about" },
  { label: "Shop", href: "#shop" },
  { label: "Ecosystem", href: "#ecosystem" },
  { label: "Contact", href: "#contact" },
];

const CHANNEL = "https://www.youtube.com/@motivationunlockedforever?sub_confirmation=1";

export default function Navbar() {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "glass" : "bg-transparent border-b border-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 group" data-testid="nav-logo">
          <img src="/logo-red.png" alt="Motivation Unlocked" className="h-10 w-auto" />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-white/70 hover:text-white transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={CHANNEL}
            target="_blank"
            rel="noreferrer"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-blaze px-4 py-2 text-sm font-bold text-white transition-transform hover:scale-105 hover:blaze-glow"
            data-testid="nav-subscribe-btn"
          >
            <Youtube size={16} /> Subscribe
          </a>
          <button
            onClick={() => setOpen(true)}
            className="relative rounded-full border border-white/20 p-2.5 hover:bg-white/10 transition-colors"
            data-testid="nav-cart-btn"
            aria-label="Open cart"
          >
            <ShoppingBag size={18} />
            {count > 0 && (
              <span
                className="absolute -top-1.5 -right-1.5 h-5 w-5 grid place-items-center rounded-full bg-blaze text-[11px] font-bold"
                data-testid="cart-count"
              >
                {count}
              </span>
            )}
          </button>
          <button
            className="md:hidden rounded-full border border-white/20 p-2.5"
            onClick={() => setMobile((m) => !m)}
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
          >
            {mobile ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {mobile && (
        <div className="md:hidden glass border-t border-white/10 px-5 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setMobile(false)}
              className="text-white/80 hover:text-white"
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href={CHANNEL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-blaze px-4 py-2 text-sm font-bold w-max"
          >
            <Youtube size={16} /> Subscribe
          </a>
        </div>
      )}
    </header>
  );
}
